export default "__VITE_ASSET__DC2Pk6VX__"